import React, { useRef, useState } from 'react';
import { object, func, string, arrayOf, bool, number, array } from 'prop-types';
import SkillsInput from '../../elements/formHook/Skills';
import SuggestedSkills from '../../skill/SuggestedSkills';
import { searchSkill } from '../../../store/skills/skills.search';

const SkillsWithSuggestions = ({
  name,
  title,
  type,
  onChange,
  suggestedSkills,
  inline,
  minLength,
  defaultSkills,
  canBeMandatory
}) => {
  const skillsRef = useRef();
  const [selectedSkillsTexts, setSelectedSkillsTexts] = useState(defaultSkills.map(({ text }) => text));
  const onSkillUpdate = (skills) => {
    setSelectedSkillsTexts(skills.map(({ text }) => text));
    onChange(type, skills);
  };
  const addSuggestedSkill = (skill) => skillsRef.current.addSkill(skill);

  return (
    <>
      <SuggestedSkills
        title={title}
        selectedSkills={selectedSkillsTexts}
        inline={inline}
        suggestedSkills={suggestedSkills}
        onSkillClick={addSuggestedSkill}
      />
      <SkillsInput
        name={name}
        ref={skillsRef}
        searchSkill={searchSkill(type)}
        minLength={minLength}
        inline={inline}
        onChange={onSkillUpdate}
        canBeMandatory={canBeMandatory}
      />
    </>
  );
};

SkillsWithSuggestions.propTypes = {
  name: string,
  title: string,
  type: string,
  onChange: func,
  inline: bool,
  suggestedSkills: arrayOf(object),
  minLength: number,
  defaultSkills: array,
  canBeMandatory: bool
};

SkillsWithSuggestions.defaultProps = {
  suggestedSkills: [],
  minLength: 0,
  onChange: () => null,
  defaultSkills: [],
  canBeMandatory: false
};

export default SkillsWithSuggestions;
